import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'

const ENTITY = 'photos'

export function getById (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).get(`${ENTITY}/${id}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function remove (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).delete(`${ENTITY}/${id}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}



// WEBPACK FOOTER //
// ./src/services/photos.service.js